import React from "react";
import { Link, useParams } from "react-router-dom";
import LanguageSwitch from "../../atoms/LanguageSwitch/LanguageSwitch";
import Layout from "../../atoms/Layout/Layout";
import Spacer from "../../atoms/Spacer/Spacer";
import useQuery from "../../hooks/useQuery";
import useTranslateDocument from "../../hooks/useTranslateDocument";
import { useUser } from "../../hooks/useUser";
import "./TourProfile.scss";

export default function TourProfile() {
  let { tourId } = useParams();
  let { user } = useUser();
  let { mappedResults } = useQuery("exhibits", "user", "==", user.uid);

  let { data: tourData } = useTranslateDocument("/tours/" + tourId);
  const tourPoints =
    tourData.points &&
    tourData.points
      .filter((id) => mappedResults.find((p) => p.id === id && p.point))
      .map((id) => {
        let point = mappedResults.find((p) => p.id === id);
        return point;
      });
  console.log(tourPoints);
  return (
    <Layout className="TourProfile">
      {tourData.id && (
        <>
          <Spacer h={12}></Spacer>
          <LanguageSwitch>
            <Spacer h={12}></Spacer>
            <div className="title">Tour: {tourData.name}</div>
            <Spacer h={12}></Spacer>

            <div className="bigButtons">
              <Link to={"/editTour/" + tourId} className="bigButton">
                1. Führung bearbeiten
              </Link>
              <Link to={"/tourExhibits/" + tourId} className="bigButton">
                2. Exponate hinzufügen
              </Link>
              <div className="bigButton">3. Schnitzeljagd</div>
            </div>
            <Spacer h={12}></Spacer>
            <div className="tourInfos">
              <div className="tourImage">
                <img src={tourData.image} alt="" />
              </div>
              <div className="tourText">{tourData.text}</div>
              <div className="tourBullets">
                <div className="tourBullet">
                  <div className="tourBulletTitle">Alter:</div>
                  {tourData.age}
                </div>
                <div className="tourBullet">
                  {" "}
                  <div className="tourBulletTitle">Zeit:</div>{" "}
                  {tourData.duration}
                </div>
                <div className="tourBullet">
                  <div className="tourBulletTitle">Stationen:</div>{" "}
                  {tourData.points.length}
                </div>
              </div>
            </div>
            <Spacer h={24}></Spacer>
            <div className="tourPoints">
              {tourPoints.map((point, i) => {
                return (
                  <div className="tourPoint">
                    <div className="tourPointImage">
                      <img
                        src={
                          point.images[0] || "https://via.placeholder.com/50"
                        }
                        alt=""
                      />
                    </div>
                    <div className="tourPointNum">{i + 1}.</div>
                    <div className="tourPointTitle">{point.name}</div>
                  </div>
                );
              })}
            </div>
          </LanguageSwitch>
        </>
      )}
    </Layout>
  );
}
